import PropTypes from 'prop-types';
import React from 'react';
import { Spin } from 'antd';
import { Button, Modal } from 'react-bootstrap';

import AirBnbDateTimePicker from '../../../common/airBnbDatepicker/AirBnbDateTimePicker';
import SelectInput from '../../../common/SelectInput';

const AddNetworkReferentModal = ({ commonState, onChange, networkReferentInModalModel, networks, saveNetworkReferent, toggle }) => {
    return (
        <Modal show={networkReferentInModalModel.show} onHide={toggle}>
            <Modal.Header closeButton>
                <Modal.Title>Referenza</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AirBnbDateTimePicker
                    name='startDate'
                    label="Data Inzio"
                    value={networkReferentInModalModel.networkReferent.startDate}
                    onChange={onChange} />
                <AirBnbDateTimePicker
                    name='endDate'
                    label="Data Fine"
                    value={networkReferentInModalModel.networkReferent.endDate}
                    onChange={onChange} />
                <SelectInput
                    disabled={networkReferentInModalModel.networkReferent.networkId > 0}
                    label="Socio Sostenitore"
                    name='networkId'
                    onChange={onChange}
                    defaultOptionText=""
                    defaultOptionValue={-1}
                    options={networks}
                    value={networkReferentInModalModel.networkReferent.networkId} />
            </Modal.Body>
            <Modal.Footer>
                <Spin spinning={commonState.blocking > 0} size="large" >
                    <Button bsStyle="success" onClick={saveNetworkReferent}>Salva</Button>
                    <Button bsStyle="warning" onClick={toggle}>Chiudi</Button>
                </Spin>
            </Modal.Footer>
        </Modal>
    );
};

AddNetworkReferentModal.propTypes = {
    commonState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    networkReferentInModalModel: PropTypes.object.isRequired,
    networks: PropTypes.array,
    saveNetworkReferent: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
};

export default AddNetworkReferentModal;
